module.exports = __webpack_public_path__ + "assets/only-house.652e27f7.svg";